import { ReactNode } from "react";
import { Sidebar, SidebarProvider, MobileHeader, useSidebar } from "./Sidebar";
import { BottomNav } from "./BottomNav";

export interface DashboardLayoutProps {
  children: ReactNode;
  /** When true, removes inner padding -- use for full-bleed pages like Agents */
  noPadding?: boolean;
}

function DashboardContent({ children, noPadding }: DashboardLayoutProps) {
  const { mobileOpen } = useSidebar();
  void mobileOpen; // keep context subscription alive

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100dvh",
        background: "hsl(var(--background))",
      }}
    >
      {/* Sidebar — sticky in document flow; expands naturally on hover */}
      <Sidebar />

      {/* Content column */}
      <div
        style={{
          flex: 1,
          minWidth: 0,
          height: "100dvh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Mobile header (fixed, only on mobile) */}
        <MobileHeader />

        {/* Page content */}
        <main
          style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}
          className="pt-14 lg:pt-0 pb-bottom-nav lg:pb-0"
        >
          {noPadding ? (
            children
          ) : (
            <div className="flex-1 min-h-0 overflow-y-auto p-4 sm:p-6 lg:p-8">{children}</div>
          )}
        </main>

        {/* Mobile bottom nav */}
        <BottomNav />
      </div>

    </div>
  );
}

export function DashboardLayout({ children, noPadding }: DashboardLayoutProps) {
  return (
    <SidebarProvider>
      <DashboardContent noPadding={noPadding}>{children}</DashboardContent>
    </SidebarProvider>
  );
}

